import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/api/index'

import Nprogress from 'nprogress';
import globalAxios from 'axios'

import router from '@/router/index'
import qs from 'qs'
Vue.use(Vuex)
const state = {
  bandwidthList: [],
  bandwidthRoles: [],
  fupTemplateList: [],
  accountId: '',
  operatorValue:'',
  createFupDatas: [],
  dynamicVendorAttributeData: [],
  dynamicVendorAttributeDataAccountId: '',
  dynamicVendorPoolName: [],
  profileList: [],
  profileListDetails: [],
  ottprofileList: [],
  ottprofileListDetails: [],
  iptvprofileList: [],
  iptvprofileListDetails: [],
  profileName: [],
  profilePermission: [],
  ottprofilePermission: [],
  iptvprofilePermission: [],
  voucherAccessTemplateList: [],
  profileData: [],
  ottProfileData:[],
  iptvProfileData:[],
  ottprofileSampleFilePath: [],
  iptvProfileData:[],
  iptvprofileSampleFilePath: [],
  voiceProfileData:[],
  voiceprofileSampleFilePath: [],
  voiceprofilePermission: [],
  voiceprofileList: [],
  voiceprofileListDetails: [],
  voiceprofileName: [],

}

const mutations = {
  SET_VOUCHER_ACCESS_TEMPLATE_LIST(state, userData) {
    var tData = {};
    var parseData = userData.message;
    state.voucherAccessTemplateList = [];
    if (parseData != null) {
      tData[userData.accountId + '-voucherAccessTemplateList'] = parseData;
      state.voucherAccessTemplateList = tData;
    }
  },
  DELETE_VOUCHER_TEMPLATE(state, data) {
    if (Object.keys(state.voucherAccessTemplateList).length != 0) {
      var index = state.voucherAccessTemplateList[data.accountId + "-voucherAccessTemplateList"].templates.findIndex(voucher => voucher.VoucherAccessTemplate.id == data.id);
      if (index != -1)
        state.voucherAccessTemplateList[data.accountId + "-voucherAccessTemplateList"].templates.splice(index, 1)
    }
  },
  ADD_EDIT_VOUCHER_TEMPLATE(state, data) {
    console.log('Data : ', data);
    var accountId = data.accountId;
    if (Object.keys(state.voucherAccessTemplateList).length != 0) {
      if (data.type == 'add') {
        state.voucherAccessTemplateList[accountId + "-voucherAccessTemplateList"].templates.push(data.voucherDetails);
      } else {
        var index = state.voucherAccessTemplateList[accountId + "-voucherAccessTemplateList"].templates.findIndex(voucher => voucher.VoucherAccessTemplate.id == data.voucherDetails.VoucherAccessTemplate.id);
        if (index != -1)
          state.voucherAccessTemplateList[accountId + "-voucherAccessTemplateList"].templates[index].VoucherAccessTemplate.price = data.voucherDetails.VoucherAccessTemplate.price;
        state.voucherAccessTemplateList[accountId + "-voucherAccessTemplateList"].templates[index].VoucherAccessTemplate.name = data.voucherDetails.VoucherAccessTemplate.name;
      }

    }
  },
  SET_FUPTEMPLATE_LIST(state, fupList) {
    var tData = {};
    tData.accountId = fupList.accountId;
    var parseData = JSON.parse(fupList.message);
    if (parseData != null) {
      if (Object.keys(state.fupTemplateList).length == 0) {
        tData[fupList.accountId + '-fupTemplateList'] = parseData;
        state.fupTemplateList = tData;
      } else {
        Vue.set(state.fupTemplateList, fupList.accountId + '-fupTemplateList', parseData);
      };
    }
  },
  ADD_FUP_LIST(state, data) {
    var fupData = data.fupdata;
    if (Object.keys(state.fupTemplateList).length != 0 && state.fupTemplateList != 'noData') {
      if (state.fupTemplateList != 'noData' || data.type == "edit" || data.type == "add") {
        for (var i = 0; i < fupData.length; i++) {
          var index = state.fupTemplateList[data.accountId + "-fupTemplateList"].findIndex(fupd => fupd.id == fupData[i].id);
          if (index != '-1') {
            state.fupTemplateList[data.accountId + "-fupTemplateList"].splice(index, 1)
          }
          state.fupTemplateList[data.accountId + "-fupTemplateList"].push(fupData[i]);

        }
      }
    } else {
      var dataSet = {}
      dataSet[data.accountId + "-fupTemplateList"] = fupData;
      state.fupTemplateList = dataSet;
    }
  },
  DELETE_FUP_LIST(state, data) {
    if (Object.keys(state.fupTemplateList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.fupTemplateList[data.accountId + "-fupTemplateList"].findIndex(fupd => fupd.id == data.ids[i]);
        state.fupTemplateList[data.accountId + "-fupTemplateList"].splice(index, 1)
      }
    }
  },
  SET_BANDWIDTH_LIST(state, bandwidthList) {
    var tData = {};
    var parseData = JSON.parse(bandwidthList.message);
    state.bandwidthRoles = parseData.pageSpecificRoles;
    state.bandwidthSampleFilePath = bandwidthList.samplePath;
    if (Object.keys(state.bandwidthList).length == 0) {
      tData[bandwidthList.accountId + '-bandwidthList'] = parseData.bandwidth;
      state.bandwidthList = tData;
    } else {
      Vue.set(state.bandwidthList, bandwidthList.accountId + '-bandwidthList', parseData.bandwidth);
    }
  },
  DELETE_BANDWIDTH_LIST(state, data) {
    if (Object.keys(state.bandwidthList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.bandwidthList[data.accountId + "-bandwidthList"].findIndex(bandwidth => bandwidth.id == data.ids[i]);
        if (index != '-1') {
          state.bandwidthList[data.accountId + "-bandwidthList"].splice(index, 1);
        }
      }
    }
  },
  ADD_BANDWIDTH_LIST(state, data) {
    var bandwidth = JSON.parse(data.banddata);
    if (bandwidth.length > 0) {
      for (var i = 0; i < bandwidth.length; i++) {
        var index = state.bandwidthList[data.accountId + "-bandwidthList"].findIndex(bandwidthd => bandwidthd.id == bandwidth[i].id);
        if (index != '-1') {
          state.bandwidthList[data.accountId + "-bandwidthList"].splice(index, 1)
        }
        state.bandwidthList[data.accountId + "-bandwidthList"].push(bandwidth[i]);
      }
    }
  },
  SET_PROFILE_LIST(state, profileListRes) {
    state.accountId = JSON.parse(profileListRes.message).accountID
    state.profilePermission = JSON.parse(profileListRes.message);
    state.profileSampleFilePath = JSON.parse(profileListRes.message).samplePath;
    var tData = {};
    if (Object.keys(state.profileList).length == 0) {
      tData[profileListRes.accountId + '-profileList'] = JSON.parse(profileListRes.message);
      state.profileList = tData;
    } else {
      Vue.set(state.profileList, JSON.parse(profileListRes.message).accountID + '-profileList', JSON.parse(profileListRes.message));
    }
    state.profileName = JSON.parse(profileListRes.message).profileName;
  },
  SET_OTT_PROFILE_LIST(state, profileListRes) {
    state.accountId = JSON.parse(profileListRes.message).accountID
    state.ottprofilePermission = JSON.parse(profileListRes.message);
    state.ottprofileSampleFilePath = JSON.parse(profileListRes.message).samplePath;
    var tData = {};
    if (Object.keys(state.ottprofileList).length == 0) {
      tData[profileListRes.accountId + '-ottProfileList'] = JSON.parse(profileListRes.message);
      state.ottprofileList = tData;
    } else {
      Vue.set(state.ottprofileList, JSON.parse(profileListRes.message).accountID + '-ottProfileList', JSON.parse(profileListRes.message));
    }
    state.ottProfileName = JSON.parse(profileListRes.message).profileName;
  },
  SET_IPTV_PROFILE_LIST(state, profileListRes) {
    state.accountId = JSON.parse(profileListRes.message).accountID
    state.iptvprofilePermission = JSON.parse(profileListRes.message);
    state.iptvprofileSampleFilePath = JSON.parse(profileListRes.message).samplePath;
    var tData = {};
    if (Object.keys(state.iptvprofileList).length == 0) {
      tData[profileListRes.accountId + '-iptvProfileList'] = JSON.parse(profileListRes.message);
      state.iptvprofileList = tData;
    } else {
      Vue.set(state.iptvprofileList, JSON.parse(profileListRes.message).accountID + '-iptvProfileList', JSON.parse(profileListRes.message));
    }
    state.ottProfileName = JSON.parse(profileListRes.message).profileName;
  },

 SET_VOICE_PROFILE_LIST(state, profileListRes) {
  state.accountId = JSON.parse(profileListRes.message).accountID
  state.voiceprofilePermission = JSON.parse(profileListRes.message);
  state.voiceprofileSampleFilePath = JSON.parse(profileListRes.message).samplePath;
  var tData = {};
  if (Object.keys(state.voiceprofileList).length == 0) {
    tData[profileListRes.accountId + '-voiceprofileList'] = JSON.parse(profileListRes.message);
    state.voiceprofileList = tData;
  } else {
    Vue.set(state.voiceprofileList, JSON.parse(profileListRes.message).accountID + '-voiceprofileList', JSON.parse(profileListRes.message));
  }
  state.voiceprofileName = JSON.parse(profileListRes.message).profileName;
},

  SET_PROFILE_DETAIL(state, data) {
    state.profileListDetails = data;
  },
  SET_OTT_PROFILE_DETAIL(state, data) {
    state.ottprofileListDetails = data;
  },
  SET_IPTV_PROFILE_DETAIL(state, data) {
    state.iptvprofileListDetails = data;
  },
  SET_VOICE_PROFILE_DETAIL(state, data) {
    state.voiceprofileListDetails = data;
  },
  ADD_PROFILE_LIST(state, data) {
    if (data.type != "import") {
      var profile = JSON.parse(data.profiledata);
    } else {
      var profile = data.profiledata;
    }
    if (profile.length > 0) {
      for (var i = 0; i < profile.length; i++) {
        var index = state.profileList[data.accountId + "-profileList"].profileName.findIndex(element => element.id == profile[i].id);
        if (index != '-1') {
          state.profileList[data.accountId + "-profileList"].profileName.splice(index, 1)
        }
        state.profileList[data.accountId + "-profileList"].profileName.push(profile[i]);
        state.profileName.push(profile[i]);
      }
    }
  },
  ADD_OTT_PROFILE_LIST(state, data) {
    if (data.type != "import") {
      var profile = JSON.parse(data.profiledata);
    } else {
      var profile = data.profiledata;
    }
    if (profile.length > 0) {
      for (var i = 0; i < profile.length; i++) {
        var index = state.ottprofileList[data.accountId + "-ottProfileList"].profileName.findIndex(element => element.id == profile[i].id);
        if (index != '-1') {
          state.ottprofileList[data.accountId + "-ottProfileList"].profileName.splice(index, 1)
        }
        state.ottprofileList[data.accountId + "-ottProfileList"].profileName.push(profile[i]);
        state.ottProfileName.push(profile[i]);
      }
    }
  },
  ADD_IPTV_PROFILE_LIST(state, data) {
    if (data.type != "import") {
      var profile = JSON.parse(data.profiledata);
    } else {
      var profile = data.profiledata;
    }
    if (profile.length > 0) {
      for (var i = 0; i < profile.length; i++) {
        var index = state.iptvprofileList[data.accountId + "-iptvProfileList"].profileName.findIndex(element => element.id == profile[i].id);
        if (index != '-1') {
          state.iptvprofileList[data.accountId + "-iptvProfileList"].profileName.splice(index, 1)
        }
        state.iptvprofileList[data.accountId + "-iptvProfileList"].profileName.push(profile[i]);
        state.iptvProfileName.push(profile[i]);
      }
    }
  },
  ADD_VOICE_PROFILE_LIST(state, data) {
    if (data.type != "import") {
      var profile = JSON.parse(data.profiledata);
    } else {
      var profile = data.profiledata;
    }
    if (profile.length > 0) {
      for (var i = 0; i < profile.length; i++) {
        var index = state.voiceprofileList[data.accountId + "-voiceprofileList"].profileName.findIndex(element => element.id == profile[i].id);
        if (index != '-1') {
          state.voiceprofileList[data.accountId + "-voiceprofileList"].profileName.splice(index, 1)
        }
        state.voiceprofileList[data.accountId + "-voiceprofileList"].profileName.push(profile[i]);
        state.voiceprofileName.push(profile[i]);
      }
    }
  },
  DELETE_PROFILE_LIST(state, data) {
    if (Object.keys(state.profileList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.profileList[data.accountId + "-profileList"].profileName.findIndex(profile => profile.id == data.ids[i]);
        var index1 = state.profileName.findIndex(profile => profile.id == data.ids[i]);
        state.profileList[data.accountId + "-profileList"].profileName.splice(index, 1)
        state.profileName.splice(index1, 1);
      }
    }
  },
  DELETE_OTT_LIST(state, data) {
    if (Object.keys(state.ottprofileList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.ottprofileList[data.accountId + "-ottProfileList"].profileName.findIndex(profile => profile.id == data.ids[i]);
        var index1 = state.ottProfileName.findIndex(profile => profile.id == data.ids[i]);
        state.ottprofileList[data.accountId + "-ottProfileList"].profileName.splice(index, 1)
        state.ottProfileName.splice(index1, 1);
      }
    }
  },
  DELETE_IPTV_LIST(state, data) {
    if (Object.keys(state.iptvprofileList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.iptvprofileList[data.accountId + "-iptvProfileList"].profileName.findIndex(profile => profile.id == data.ids[i]);
        var index1 = state.iptvProfileName.findIndex(profile => profile.id == data.ids[i]);
        state.iptvprofileList[data.accountId + "-iptvProfileList"].profileName.splice(index, 1)
        state.iptvProfileName.splice(index1, 1);
      }
    }
  },
  DELETE_VOICE_PROFILE_LIST(state, data) {
    if (Object.keys(state.profileList).length != 0) {
      for (var i = 0; i < data.ids.length; i++) {
        var index = state.profileList[data.accountId + "-voiceprofileList"].voiceprofileName.findIndex(profile => profile.id == data.ids[i]);
        var index1 = state.voiceprofileName.findIndex(profile => profile.id == data.ids[i]);
        state.profileList[data.accountId + "-voiceprofileList"].voiceprofileName.splice(index, 1)
        state.voiceprofileName.splice(index1, 1);
      }
    }
  },
  DEACTIVATE_PROFILE_LIST(state, data) {
    if (Object.keys(state.profileList).length != 0) {
      // for (var i = 0; i < data.ids.length; i++) {
      // var index = state.profileList[data.accountId + "-profileList"].findIndex(profile => profile.id == data.ids[i]);
      // state.profileList[data.accountId + "-profileList"].splice(index, 1)
      // }
    }
  },
  UPDATE_FUPZONE(state, data) {
    state.fupTemplateList = data;
  },
  SET_FUP_ZONE_CHANGE(state, data) {
    state.accountId = data;
  },
  SET_FUP_CREATE_DATAS(state, data) {
    if (data.createData != undefined) {
      state.createFupDatas = data.createData;
    } else {
      state.createFupDatas = data;
    }
  },
  SET_FAILURE(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'error',
      text: error
    });
  },
  SET_SUCCESS(state, error) {
    Nprogress.done();
    Vue.notify({
      group: 'foo',
      type: 'success',
      text: error
    });
  },
  SET_DYNAMIC_VENDOR_LIST(state, data) {
    state.dynamicVendorAttributeDataAccountId = data.datas
    var tData = {};
    if (Object.keys(state.dynamicVendorAttributeData).length == 0) {
      tData[data.accountId + '-dynamicVendorList'] = data.datas;
      state.dynamicVendorAttributeData = tData;
    } else {
      Vue.set(state.dynamicVendorAttributeData, data.accountId + '-dynamicVendorList', data.datas);
    }
  },
  ADD_DYNAMIC_VENDOR_DATA(state, data) {
    var dynamicData = data.dynamicdata;
    if (dynamicData.length > 0) {
      for (var i = 0; i < dynamicData.length; i++) {
        var index = state.dynamicVendorAttributeData[data.accountId + "-dynamicVendorList"].dynamicVendors.findIndex(dynamicd => dynamicd.DynamicVendorAttributes.id == dynamicData[i].DynamicVendorAttributes.id);
        if (index != '-1') {
          state.dynamicVendorAttributeData[data.accountId + "-dynamicVendorList"].dynamicVendors.splice(index, 1)
        }
        state.dynamicVendorAttributeData[data.accountId + "-dynamicVendorList"].dynamicVendors.push(dynamicData[i]);
      }
    }
  },
  DELETE_DYNAMIC_VENDOR_ATTRIBUTE(state, data) {
    var dynamicData = data;
    var index = state.dynamicVendorAttributeData[data.DynamicVendorAttributes.account_id + "-dynamicVendorList"].dynamicVendors.findIndex(dynamicd => dynamicd.DynamicVendorAttributes.id == dynamicData.DynamicVendorAttributes.id);
    state.dynamicVendorAttributeData[data.DynamicVendorAttributes.account_id + "-dynamicVendorList"].dynamicVendors.splice(index, 1)
  },
  SET_DYNAMIC_VENDOR_POOL_NAME(state, data) {
    state.dynamicVendorPoolName = data;
  },
  SET_ADD_EDIT_PROFILE(state, data) {
    state.profileData = data.message;
  },
  SET_ADD_EDIT_OTT_PROFILE(state, data) {
    state.ottProfileData = data.message;
  },
  SET_ADD_EDIT_IPTV_PROFILE(state, data) {
    state.iptvProfileData = data.message;
  },
  SET_ADD_EDIT_VOICE_PROFILE(state, data) {
    state.voiceProfileData = data.message;
  },

  UPDATE_PROFILE_PLAN(state, data) {
    if (data.profileType == "IPTV" || data.profileType == "IPPhone") {
      Vue.set(state.profileData, 'jbillPlansIP', data.planName);
    } else {
      Vue.set(state.profileData, 'jbillPlans', data.planName);
    }
  },
  UPDATE_OTT_PLAN(state, data) {    
    if(data.from == "ott_profile_page") {
      Vue.set(state.ottProfileData, 'ottPlans', data.message);
      state.operatorValue=data.operatorValue;
    } else {
      Vue.set(state.profileData, 'ottPlans', data.message);
      state.operatorValue=data.operatorValue;
    }
  },
  UPDATE_VOICEPHONE_PLAN(state, data) {
    Vue.set(state.voiceProfileData, 'voicePhonePlans', data.message);
},
  UPDATE_VOICEPHONE_PLAN1(state, data) {
    console.log("test1", data.message);
    Vue.set(state.voiceProfileData, 'voicePhonePlans', data.message);
  },
  CLEAR_PROFILES_STATE(state) {
    state.bandwidthList = [];
    state.bandwidthSampleFilePath = '';
    state.profileSampleFilePath = '';
    state.ottprofileSampleFilePath = '';
    state.bandwidthRoles = [];
    state.fupTemplateList = [];
    state.accountId = '';
    state.operatorValue='';
    state.createFupDatas = [];
    state.dynamicVendorAttributeData = [];
    state.profileList = [];
    state.profileListDetails = [];
    state.ottprofileList = [];
    state.ottprofileListDetails = [];
    state.iptvprofileList = [];
    state.iptvprofileListDetails = [];
    state.profileName = [];
    state.ottProfileName = [];
    state.iptvProfileName = [];
    state.profilePermission = [];
    state.ottprofilePermission = [];
    state.iptvprofilePermission = [];
    state.profileData = [];
    state.ottProfileData=[];
    state.iptvProfileData=[];
    state.voiceprofileSampleFilePath = '';
    state.voiceprofileName = [];
    state.voiceProfileData=[];
    state.voiceprofileList = [];
    state.voiceprofileListDetails = [];
    state.voiceprofilePermission = [];
  }
}

const actions = {
  addFupToAllSubZones({
      commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/add_fup_template_to_all_accounts', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data.genericBody);
        })
        .catch(error => console.log(error));
    });
  },
  getVoucherAccessTemplateList({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.get('/profiles/voucher_access_template/true')
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data);
            return;
          }
          commit("SET_VOUCHER_ACCESS_TEMPLATE_LIST", response.data);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteVoucherTemplate({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_voucher_template', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            id: response.data.id,
            accountId: postData.accountId
          }
          commit('DELETE_VOUCHER_TEMPLATE', data)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditVoucherAccessTemplateSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/voucher_access_template/true', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var data = {
            voucherDetails: response.data.voucherDetails,
            accountId: postData.accountId,
            type: postData.type
          }
          commit('ADD_EDIT_VOUCHER_TEMPLATE', data)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchBandwidthList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/bandwidth_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_BANDWIDTH_LIST', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  addEditBandwidthModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/bandwidth', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            banddata: response.data.bandwidthId,
            accountId: postData.accountId
          }
          if (!postData.fromProfile) {
            commit('ADD_BANDWIDTH_LIST', dataList);
          }


          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, deleteBandwidthModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_bandwidth.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_BANDWIDTH_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, importBandwidthCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_bandwidth_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            banddata: response.data.bandwidthData,
            accountId: accountId
          }
          commit('ADD_BANDWIDTH_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importBandwidthModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_bandwidth_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            banddata: response.data.bandwidthData,
            accountId: accountId
          }
          commit('ADD_BANDWIDTH_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  }, quickCreateModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/bandwidth', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            banddata: response.data.bandwidthId,
            accountId: postData.accountId
          }
          commit('ADD_BANDWIDTH_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchFupTemplateList({
    commit,
    dispatch
  }, authData) {
    return new Promise((resolve, reject) => {
      Nprogress.start()
      axios.get('/profiles/fup_template_list')
        .then(res => {
          Nprogress.done()
          if (res.data.status == "redirect") {
            router.push(res.data.message);
          } else {
            commit('SET_FUPTEMPLATE_LIST', res.data)
            commit('SET_FUP_CREATE_DATAS', res.data);
          }
          resolve(res.data);

        })
        .catch(error => console.log(error))
    });
  },
  fetchProfileList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/profile_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_PROFILE_DETAIL', res.data.profileDetail)
          commit('SET_PROFILE_LIST', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  fetchOttList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/ott_profile_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_OTT_PROFILE_DETAIL', res.data.profileDetail)
          commit('SET_OTT_PROFILE_LIST', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  fetchIptvProfilesList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/iptv_profiles')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_IPTV_PROFILE_DETAIL', res.data.profileDetail)
          commit('SET_IPTV_PROFILE_LIST', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  fetchVoiceProfileList({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/voice_profile_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_VOICE_PROFILE_DETAIL', res.data.profileDetail)
          commit('SET_VOICE_PROFILE_LIST', res.data)
        }
      })
      .catch(error => console.log(error))
  },
  deleteProfileModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_all_profiles.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          console.log(response);
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_PROFILE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteIspSubPlan({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_isp_sub_plan', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }         
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteOttModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_all_ott_profiles.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          console.log(response);
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_OTT_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteIptvModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_all_iptv_profiles.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          console.log(response);
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_IPTV_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteVoiceProfileModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_all_voice_profiles.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          console.log(response);
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_VOICE_PROFILE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deactivateProfileModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/package_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            //commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          //commit('SET_SUCCESS', response.data.message);
          
          commit('SET_PROFILE_DETAIL', response.data.profileList.profileDetail)
          commit('SET_PROFILE_LIST', response.data.profileList)
          // var successData = {
          //   accountId: postData.accountId
          // }
         // commit('DEACTIVATE_PROFILE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deactivateOttModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/ott_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          
          commit('SET_OTT_PROFILE_DETAIL', response.data.profileList.profileDetail)
          commit('SET_OTT_PROFILE_LIST', response.data.profileList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deactivateIptvModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/iptv_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          
          commit('SET_IPTV_PROFILE_DETAIL', response.data.profileList.profileDetail)
          commit('SET_IPTV_PROFILE_LIST', response.data.profileList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deactivateVoiceProfileModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/voice_package_deactivate', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            //commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          //commit('SET_SUCCESS', response.data.message);
          
          commit('SET_VOICE_PROFILE_DETAIL', response.data.profileList.profileDetail)
          commit('SET_VOICE_PROFILE_LIST', response.data.profileList)
          // var successData = {
          //   accountId: postData.accountId
          // }
         // commit('DEACTIVATE_PROFILE_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importProfileCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_profiles_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_PROFILE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importOttProfileCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_ott_profiles_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_OTT_PROFILE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importVoiceProfileCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_voice_profiles_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_VOICE_PROFILE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importProfileModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_profiles_file', postData)
        .then(response => {
          console.log("inport Response", response);
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_PROFILE_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importOttProfileModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_ott_profiles_file', postData)
        .then(response => {
          console.log("import Response", response);
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_OTT_PROFILE_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importIptvProfileModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_iptv_profiles_file', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_IPTV_PROFILE_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importVoiceProfileModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_voice_profiles_file', postData)
        .then(response => {
          console.log("import Response", response);
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_VOICE_PROFILE_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importIptvProfileCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_iptv_profiles_file_copy', postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            commit('SET_FAILURE', response.data.message);
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            profiledata: response.data.profileData,
            accountId: accountId,
            type: "import"
          }
          commit('ADD_IPTV_PROFILE_LIST', dataList)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  clearProfilesState({
    commit,
    dispatch
  }) {
    commit('CLEAR_PROFILES_STATE')
  },
  addEditFupModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/fup_template/' + postData.fupAccountId, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()

          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            fupdata: response.data.fupTempid,
            accountId: postData.fupAccountId,
            type: postData.type
          }
          commit('ADD_FUP_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteFupTemplateModalSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_fuptemplate.json', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var successData = {
            ids: response.data.successIds,
            accountId: postData.accountId
          }
          commit('DELETE_FUP_LIST', successData);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importFupModal({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_fup_file/' + state.accountId, postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            fupdata: response.data.fupData,
            accountId: response.data.fupData[0].account_id
          }
          commit('ADD_FUP_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  importFupCopy({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/import_fup_file_copy/' + state.accountId, postData)
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          var accountId = '';
          for (let [key, val] of postData.entries()) {
            if (key == 'accountId') {
              accountId = val;
              break;
            }
          }
          var dataList = {
            fupdata: response.data.fupData,
            accountId: response.data.fupData[0].account_id
          }

          commit('ADD_FUP_LIST', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fupZoneChange({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {

      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/fup_template/' + postData)
        .then(response => {
          loader.hide()
          commit('SET_FUP_CREATE_DATAS', response.data.createData);
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          if (response.data.fupTempid == null) {
            state.fupTemplateList = [];
            return
          }
          commit('SET_FUP_ZONE_CHANGE', postData);
          var dataSet = {}
          dataSet[postData + "-fupTemplateList"] = response.data.fupTempid;
          commit("UPDATE_FUPZONE", dataSet);
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchDynamicVendorAttribute({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get('/profiles/dynamic_vendor_attributes_list')
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_DYNAMIC_VENDOR_LIST', res.data)
        }

      })
      .catch(error => console.log(error))
  },
  addEditDynamicVendor({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/create_dynamic_vendor', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          var dataList = {
            dynamicdata: response.data.newData,
            accountId: response.data.accountId,
            type: postData.type
          }
          commit('ADD_DYNAMIC_VENDOR_DATA', dataList)

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  deleteDynamicVendor({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/delete_dynamic_vendor', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          commit("DELETE_DYNAMIC_VENDOR_ATTRIBUTE", response.data.deletedData)
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchDynamicVendorPoolName({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    var id = authData.userId;
    var accountId = authData.accountId;
    axios.get('/profiles/dynamic_vendor_vlan_pool_names_list/' + id + '/' + accountId)
      .then(res => {
        Nprogress.done();
        commit('SET_DYNAMIC_VENDOR_POOL_NAME', res.data.datas);

      })
      .catch(error => console.log(error))
  },
  createDynamicPoolNames({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/create_dynamic_pool_names', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  pushToSubZone({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/push_all_profiles', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  iptvPushToSubZone({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/push_all_iptv_profiles', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  ottPushToSubZone({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/push_all_ott_profiles', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  voicepushToSubZone({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      //Nprogress.start()
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/push_all_voice_profiles', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditProfileSubmit({
    commit,
    dispatch
  }, data) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = data.postData;
      var url = data.url;
      axios.post(url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditOttProfileSubmit({
    commit,
    dispatch
  }, data) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = data.postData;
      var url = data.url;
      axios.post(url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditIptvProfileSubmit({
    commit,
    dispatch
  }, data) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = data.postData;
      var url = data.url;
      axios.post(url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  addEditVoiceProfileSubmit({
    commit,
    dispatch
  }, data) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      var postData = data.postData;
      var url = data.url;
      axios.post(url, qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
  fetchAditEditOttProfile({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get(authData.path)
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_ADD_EDIT_OTT_PROFILE', res.data);
        }
      })
      .catch(error => console.log(error))
  },
  fetchAditEditIptvProfile({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get(authData.path)
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_ADD_EDIT_IPTV_PROFILE', res.data);
        }
      })
      .catch(error => console.log(error))
  },
  fetchAditEditVoiceProfile({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get(authData.path)
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_ADD_EDIT_VOICE_PROFILE', res.data);
        }
      })
      .catch(error => console.log(error))
  },
  fetchAditEditProfile({
    commit,
    dispatch
  }, authData) {
    Nprogress.start()
    axios.get(authData.path)
      .then(res => {
        Nprogress.done()
        if (res.data.status == "redirect") {
          router.push(res.data.message);
        } else {
          commit('SET_ADD_EDIT_PROFILE', res.data);
        }
      })
      .catch(error => console.log(error))
  },
  billingRangeFormSubmit({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/profile_billing_model', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          var data = response.data;
          data['profileType'] = postData.profileType
          commit('UPDATE_PROFILE_PLAN', data);
        })
        .catch(error => console.log(error));
    });
  },
  getusergroup({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/get_ott_plans', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          if(postData.from == "ott_profile_page") {
            response.data.from = "ott_profile_page";
            commit('UPDATE_OTT_PLAN', response.data);
          } else {
            commit('UPDATE_OTT_PLAN', response.data);
          }
        })
        .catch(error => console.log(error));
    });
  },
  getVoicePhonePlans({
    commit,
    dispatch
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/get_nexge_plans', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }
          resolve(response.data);
          commit('UPDATE_VOICEPHONE_PLAN', response.data);
        })
        .catch(error => console.log(error));
    });
  },
  applyTestPackage({
    commit
  }, postData) {
    return new Promise((resolve, reject) => {
      let loader = Vue.$loading.show({
        canCancel: false,
      });
      axios.post('/profiles/apply_testPack', qs.stringify(postData, {
        parseArrays: false
      }))
        .then(response => {
          loader.hide()
          if (response.data.status != 'success') {
            reject(response.data.message);
            return;
          }

          resolve(response.data);
        })
        .catch(error => console.log(error));
    });
  },
}

const getters = {
  getVoucherAccessTemplateListGetters: state => {
    return state.voucherAccessTemplateList;
  },
  getOperatorValueGetters: state=>{
    return state.operatorValue;
  },
  getBandwidthListGetters: state => {
    return state.bandwidthList;
  },
  getBandwidthRolesGetters: state => {
    return state.bandwidthRoles;
  },
  fupTemplateListGetters: state => {
    return state.fupTemplateList;
  },
  getAccountIdGetters: state => {
    return state.accountId;
  },
  createFupDatasGetters: state => {
    return state.createFupDatas;
  },
  dynamicVendorAttributesGetter: state => {
    return state.dynamicVendorAttributeData;
  },
  dynamicVendorAttributesAccountIdGetter: state => {
    return state.dynamicVendorAttributeDataAccountId;
  },
  dynamicVendorPoolNameGetter: state => {
    return state.dynamicVendorPoolName
  },
  getProfileListGetters: state => {
    return state.profileList;
  },
  getProfileListDetailsGetters: state => {
    return state.profileListDetails;
  },
  geOttProfileListGetters: state => {
    return state.ottprofileList;
  },
  getOttProfileListDetailsGetters: state => {
    return state.ottprofileListDetails;
  },
  geIptvProfileListGetters: state => {
    return state.iptvprofileList;
  },
  getIptvProfileListDetailsGetters: state => {
    return state.iptvprofileListDetails;
  },
  getProfileNamesGetters: state => {
    return state.profileName;
  },
  getOttProfileNamesGetters: state => {
    return state.ottProfileName;
  },
  getIptvProfileNamesGetters: state => {
    return state.iptvProfileName;
  },
  getProfilePermissionGetters: state => {
    return state.profilePermission;
  },
  getOttProfilePermissionGetters: state => {
    return state.ottprofilePermission;
  },
  getIptvProfilePermissionGetters: state => {
    return state.iptvprofilePermission;
  },
  getsamplebandwidthSampleFilePath: state => {
    return state.bandwidthSampleFilePath;
  },
  getsampleprofileSampleFilePath: state => {
    return state.profileSampleFilePath;
  },
  getsampleottprofileSampleFilePath: state => {
    return state.ottprofileSampleFilePath;
  },
  getsampleiptvprofileSampleFilePath: state => {
    return state.iptvprofileSampleFilePath;
  },
  profileDataGetter: state => {
    return state.profileData;
  },
  ottProfileDataGetter: state => {
    return state.ottProfileData;
  },
  iptvProfileDataGetter: state => {
    return state.iptvProfileData;
  },
  getVoiceProfileListGetters: state => {
    return state.voiceprofileList;
  },
    getVoiceProfileListDetailsGetters: state => {
    return state.voiceprofileListDetails;
  },
   getVoiceProfileNamesGetters: state => {
    return state.voiceprofileName;
  },
   getVoiceProfilePermissionGetters: state => {
    return state.voiceprofilePermission;
  },
    getsamplevoiceprofileSampleFilePath: state => {
    return state.voiceprofileSampleFilePath;
  },
   voiceProfileDataGetter: state => {
    return state.voiceProfileData;
  },

}

export default {
  state,
  mutations,
  actions,
  getters
}
